<script setup></script>

<template>
  <div class="desktop-footer">
    <div class="footer-content">
      <img src="@/assets/img/web_home/icon @2x.png" class="pegi-icon" />
      <div class="footer-text">
        <p>This game contains violence and combat depictions, rated PEGI 12.</p>
        <p>
          WARNING: Limit your playtime to avoid problematic gaming consumption. This game features
          optional in-game purchases, please spend prudently.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.desktop-footer {
  display: flex;
  width: 100%;
  background: #1e3a5f;
  padding: 20px 0;
  justify-content: center;
  margin-top: auto; /* Push to bottom if content is short */
}

.footer-content {
  display: flex;
  align-items: center;
  gap: 20px;
  color: #fff;
  font-size: 12px;
}

.pegi-icon {
  width: 50px;
  height: auto;
}
</style>
